import { Observable, lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface CheckoutCustomizationPayload {
  colorButton: string | null;
  colorBotton: string | null;
  colorWindow: string | null;
  urlImagemLogo: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  constructor(private http: HttpClient) {}

  changeWebhookDeposit(urlDeposito: string): Promise<any> {
    const payloadDeposito = { url: urlDeposito };
    return lastValueFrom(
      this.http.put(`${environment.apiUrl}/digitopay/webhook/deposit`, payloadDeposito)
    );
  }

  getWebhookDeposit(): Promise<any> {
    return lastValueFrom(
      this.http.get(`${environment.apiUrl}/digitopay/webhook/deposit`)
    );
  }

  changeWebhookWithDraw(urlSaque: string): Promise<any> {
    const payloadSaque = { url: urlSaque };
    return lastValueFrom(
      this.http.put(`${environment.apiUrl}/digitopay/webhook/withdraw`, payloadSaque)
    );
  }

  getWebhookWithDraw(): Promise<any> {
    return lastValueFrom(
      this.http.get(`${environment.apiUrl}/digitopay/webhook/withdraw`)
    );
  }

  getCustomizationColorUser(): Promise<any> {
    return lastValueFrom(
      this.http.get(`${environment.apiUrl}/getcustomizationcoloruser`)
    );
  }

  saveCustomizationColorUser(payload: CheckoutCustomizationPayload): Promise<any> {
    return lastValueFrom(
      this.http.post(`${environment.apiUrl}/customizationcoloruser`, payload)
    );
  }
}
